import React, { useEffect, useState } from "react";
import * as apiInfo from '../../services/ApiInformation'
import { Box, Button, FormControl, MenuItem, Pagination, Select, Tooltip, IconButton } from "@mui/material";
import moment from "moment";
import CircleIcon from '@mui/icons-material/Circle';
import _ from 'lodash'
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import Loader from "../../components/Loader";
import backIcon from '../../assets/icons/backicon.svg'
import { notifyError } from '../../components/NotifyToast'
import styles from './MedicalInformation.module.css'

import { IoArrowBackOutline } from "react-icons/io5";
import { LuDoorOpen } from "react-icons/lu";
import { FaBedPulse } from "react-icons/fa6";

import { BsClipboard2PulseFill } from "react-icons/bs";
import { TbTestPipe } from "react-icons/tb";
import { FaUserDoctor } from "react-icons/fa6";
import { FaFilePrescription } from "react-icons/fa6";

import { config } from '../../config.env';

function NoData() 
{
    return (
    <Box sx={{
        display: 'flex',
        height:'90%',
        justifyContent: 'center',
        alignItems: 'center',
        color: 'secondary.main'
    }}>
        ไม่พบข้อมูล
    </Box>);
}

function randomDate(msFrom=946659600,msTo)
{
    if (!msTo)
        msTo = Date.now();
    return new Date(msFrom + (Math.random()*(msTo-msFrom))).toISOString().slice(0,10);
}

function irandom(r) {
    return Math.round(Math.random()*r);
}

function generateRandomString(length) {
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  let result = '';
  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * characters.length));
  }
  return result;
}

export default function MedicalInformationNew() {

    const location = useLocation()
    const navigate = useNavigate()
    const pid = useSelector((state) => state.auth.user_data.pid);
    const [loading, setLoading] = useState(false)
    const [value, setValue] = useState(0);

    const [hospital, setHospital] = useState('')
    const [optionHospital, setOptionHospital] = useState([])
    const [date, setDate] = useState('')
    const [optionDate, setOptionDate] = useState([])

    const [dataInformation, setDataInformation] = useState([])
    const [dataPersonal, setDataPersonal] = useState([])

    const [dataAll, setDataAll] = useState([])

    const [page, setPage] = useState(1)
    const [maxPage, setMaxPage] = useState(1)
    const [showList, setShowList] = useState([])

    const [menuSelected, setMenuSelected] = useState();

    const [isPortrait, setIsPortrait] = useState(window.matchMedia("(orientation: portrait)").matches);

    useEffect(() => {
        const mediaQuery = window.matchMedia("(orientation: portrait)");

        const handler = (e) => {
            setIsPortrait(e.matches);
        };

        mediaQuery.addEventListener("change", handler);

        return () => {
            mediaQuery.removeEventListener("change", handler);
        };
    }, []);

    useEffect(() => {
        setDate('')
        if (hospital === ' ' || hospital === '') {
            findInformation()
        } else {
            filterDataHospital()
        }
    }, [hospital])

    useEffect(() => {
        if (hospital === ' ' || hospital === '') {
            if (date === ' ' || date === '') {
                findInformation()
            } else {
                filterDataInformationDate()
            }
        } else {
            if (date === ' ' || date === '') {
                filterDataHospital()
            } else {
                filterDataInformationDate()
            }
        }
    }, [date])

    const findInformation = async () => {

        setLoading(true)
        let res = await apiInfo.getInformation(pid, hospital === " " ? "" : hospital)
        setLoading(false)

        // MockUp
        if (!res && !config.PRODUCTION)
        {
            console.log("Mockup HealthHistory");
            res = {
                personal_information_list: [
                    {
                        pname: 'นาย',
                        fname: 'ทดสอบ',
                        lname: 'การแสดงผล',
                        address: {
                            full_address: 'ที่อยู่ของผม'
                        },
                        pid: '1101234567890',
                        home_phone: `02${(Math.round(Math.random()*10000000)).toString().padStart(7,'0')}`,
                        birthday: `${Math.round(1940+(Math.random()*90)).toString().padStart(2,'0')}-${Math.round(1+Math.random()*11).toString().padStart(2,'0')}-${Math.round(1+Math.random()*29).toString().padStart(2,'0')}`,
                        phone_number: `08${(Math.round(Math.random()*100000000)).toString().padStart(8,'0')}`,
                        age: 18+Math.round(Math.random()*82),
                        hos_name: 'รพ. ทดสอบ',
                        hn: 'HN-123456789',
                        blood_group: 'B',
                        drug_allergy: 'ไม่มี',
                    }
                ],
                visit_information_list: [],
                labs_information_list: [],
                diagnosis_information_list: [],
                order_information_list: [],
            };

            const n = irandom(8);
            for (let i=0; i<n; i++)
            {
                const date = randomDate();

                if (Math.random() >= 0.5)
                {
                    res.visit_information_list.push({
                        hos_id: '00000',
                        visit_date: date,
                        cc: generateRandomString(irandom(64)),
                        ht: 50+irandom(50),
                        pi: 50+irandom(50),
                        bt: 50+irandom(50),
                        pe: 50+irandom(50),
                        rr: 50+irandom(50),
                        bp: 60+irandom(80),
                        bmi: 15+irandom(20),
                        pr: 50+irandom(50),
                        sat_o2: 90+irandom(10),
                        bw: 50+irandom(50),
                    });
                }

                if (Math.random() >= 0.5)
                {
                    res.labs_information_list.push({
                        hos_id: '00000',
                        visit_date: date,
                        lab_list: [
                            {
                                detail: [
                                    'Detail'+generateRandomString(irandom(64)),
                                    'Detail'+generateRandomString(irandom(64)),
                                ]
                            },
                            {
                                detail: [
                                    'Detail'+generateRandomString(irandom(64)),
                                    'Detail'+generateRandomString(irandom(64)),
                                ]
                            }
                        ]
                    });
                }

                if (Math.random() >= 0.5)
                {
                    res.diagnosis_information_list.push({
                        hos_id: '00000',
                        visit_date: date,
                        diagnosis: [
                            {diag: 'Diag'+generateRandomString(16)},
                            {diag: 'Diag'+generateRandomString(16)}
                        ]
                    });
                }
                
                if (Math.random() >= 0.5)
                {
                    res.order_information_list.push({
                        hos_id: '00000',
                        visit_date: date,
                        order_list: [
                            {med: 'Med'+generateRandomString(32)},
                            {med: 'Med'+generateRandomString(32)}
                        ]
                    });
                }
            }
        }

        console.log(res);
        if (res)
        {
            //option hospital
            filterHospitalOption(res["personal_information_list"]);

            //ข้อมูลส่วนตัว
            setDataPersonal(res['personal_information_list'])

            setMaxPage((Math.ceil(res['personal_information_list'].length / 1)))

            // เรียงข้อมูลแยกตามวันที่
            let date_list = res.visit_information_list.map((item) => ({
                hos_id: item.hos_id,
                hos_name: item.hos_name,
                visit_date: item.visit_date,
                visit_information_list: [],
                labs_information_list: [],
                diagnosis_information_list: [],
                order_information_list: [],
            }));
            date_list = date_list.concat(
                res.labs_information_list.map((item) => ({
                hos_id: item.hos_id,
                hos_name: item.hos_name,
                visit_date: item.visit_date,
                visit_information_list: [],
                labs_information_list: [],
                diagnosis_information_list: [],
                order_information_list: [],
                }))
            );
            date_list = date_list.concat(
                res.diagnosis_information_list.map((item) => ({
                hos_id: item.hos_id,
                hos_name: item.hos_name,
                visit_date: item.visit_date,
                visit_information_list: [],
                labs_information_list: [],
                diagnosis_information_list: [],
                order_information_list: [],
                }))
            );
            date_list = date_list.concat(
                res.order_information_list.map((item) => ({
                hos_id: item.hos_id,
                hos_name: item.hos_name,
                visit_date: item.visit_date,
                visit_information_list: [],
                labs_information_list: [],
                diagnosis_information_list: [],
                order_information_list: [],
                }))
            );
            date_list = _.orderBy(
                _.uniqBy(date_list, "visit_date"),
                ["visit_date"],
                ["desc"]
            );

            date_list.forEach((item_) => {
                item_.visit_information_list = res.visit_information_list.filter(
                (item) => item.visit_date === item_.visit_date
                );
                item_.labs_information_list = res.labs_information_list.filter(
                (item) => item.visit_date === item_.visit_date
                );
                item_.diagnosis_information_list =
                res.diagnosis_information_list.filter(
                    (item) => item.visit_date === item_.visit_date
                );
                item_.order_information_list = res.order_information_list.filter(
                (item) => item.visit_date === item_.visit_date
                );
            });
            setDataInformation(date_list)
            setDataAll(date_list)
            //console.log(date_list)

            setMenuSelected(Array(date_list.length).fill(0))
            //option date
            const List = []
            for (let i = 0; i < date_list.length; i++) {
                if (date_list[i]) {
                    List.push(date_list[i]['visit_date'])
                }
            }
            setOptionDate(List)
        }
        else notifyError('ไม่ตอบสนอง');
    }

    useEffect(() => {
        let start = page * 1 - 1
        setShowList(dataPersonal.slice(start, start + 1))
    }, [page, dataPersonal])

    const handlePageChange = (event, page) => {
        setPage(page)
    }

    const filterHospitalOption = (personalInfoList) => {
        let option = [];
        for (let i = 0; i < personalInfoList.length; i++) {
        if (personalInfoList[i]) {
            option.push({
            key: personalInfoList[i]["hos_id"],
            value: personalInfoList[i]["hos_name"],
            });
        }
        }
        const unique = [...new Map(option.map((m) => [m.key, m])).values()]; //กรองชื่อซ้ำ
        setOptionHospital(unique);
        //console.log(unique)
    }

    const filterDataInformationDate = () => {
        const List = []
        for (let i = 0; i < dataAll.length; i++) {
            if (dataAll[i]['visit_date'] === date) {
                List.push(dataAll[i])
            }
        }
        setDataInformation(List)
        // console.log(List)
    }

    const filterDataHospital = () => {
        // console.log(dataAll)
        setDate('')

        const personal = []
        for (let i = 0; i < dataPersonal.length; i++) {
            if (dataPersonal[i]['hos_id'] === hospital) {
                personal.push(dataPersonal[i])
            }
        }
        setShowList(personal)
        setPage(1)
        setMaxPage((Math.ceil(personal.length / 1)))

        const List = []
        for (let i = 0; i < dataAll.length; i++) {
            if (dataAll[i]['hos_id'] === hospital) {
                List.push(dataAll[i])
            }
        }
        setDataInformation(List)
        //console.log(List)

        const Date = []
        for (let i = 0; i < List.length; i++) {
            if (List[i]) {
                Date.push(List[i]['visit_date'])
            }
        }
        setOptionDate(Date)
    }

    const convertDate = (dataDate) => {
        const date = new Date(dataDate)
        const optionDate = {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
            timeZone: 'UTC',
        }

        const thaiLocale = 'th-TH';
        const formattedDate = date.toLocaleDateString(thaiLocale, optionDate)

        const newDate = `${formattedDate}`
        return newDate
    }

    const dataSetMenu = (index, value) => {
        let tmp = menuSelected;
        if (menuSelected.length !== dataInformation.length) {
            tmp = Array(dataInformation.length).fill(0);
        }

        tmp[index] = value;
        setMenuSelected([...tmp]);
    }

    return (
    <>
        <Loader loading={loading} />
        <Box sx={{
            color: '#263238',
            display: 'grid',
            gridGap: 20,
            fontSize: 18,
            m: { xl: '2rem', lg: '2rem', md: '2rem', sm: '2rem', xs: '2rem 1rem' },
            '@media (max-width: 1023px)': { fontSize: 16, },
            '@media (max-width: 800px)': { fontSize: 14, },
            '@media (orientation: portrait)': { fontSize: '6vw', }
        }}>

            <Box sx={{
                display: 'grid',
                gridTemplateColumns: '1fr 1fr 1fr',
                '@media (orientation: portrait)': {
                    gridTemplateColumns: '1fr 3fr 1fr',
                    mb: 0,
                    '@media (min-width: 1000px)': {
                        m: '1em',
                        mb: 2
                    },
                }
            }}>

                <Box sx={{
                    display: 'flex',
                    justifyContent: 'start',
                    ml: '3rem',
                    '@media (orientation: portrait)': {
                        ml: 0,
                    }
                }}>
                    <Tooltip title="ย้อนกลับ">
                        <IconButton onClick={() => { navigate('/mainMenu') }} color="c_button" variant="resp" aria-label="Back">
                            <IoArrowBackOutline size='1.25em'/>
                        </IconButton>
                    </Tooltip>
                </Box>

                <Box sx={{
                    textAlign: 'center',
                    alignSelf: 'end',
                    color: 'c_title.main',
                    '@media (orientation: portrait)': {
                        alignSelf: 'center',
                    }
                }}>
                    ข้อมูลทางการแพทย์
                </Box>

            </Box>

            <Box sx={{
                display: 'flex',
                justifyContent: 'center',
                gap: 6,
                '@media (orientation: portrait)': {
                    mb: '0.5em',
                }
            }}>
                <Tooltip title="ประวัติผู้ป่วยนอก">
                    <IconButton
                        onClick={() => { setValue(0); }} color="c_button" variant={value === 0 ? "resp1" : "resp0"} aria-label="Outpatient Records"
                    >
                        <LuDoorOpen/>
                    </IconButton>
                </Tooltip>

                <Tooltip title="ประวัติการนอนโรงพยาบาล">
                    <IconButton
                        onClick={() => { setValue(1); }} color="c_button" variant={value === 1 ? "resp1" : "resp0"} aria-label="Inpatient Records"
                    >
                        <FaBedPulse/>
                    </IconButton>
                </Tooltip>
            </Box>
        

            {value === 1 && dataPersonal.length > 0 &&
                <Box sx={{
                    border: 1,
                    borderRadius: '0.75em',
                    borderColor: '#E1E3E9',
                    bgcolor: '#FFF',
                    mx: 1,
                    '@media (orientation: portrait)': {
                        fontSize: '0.5em',
                    }
                }}>
                    <Box sx={{
                        color: '#082C91',
                        fontWeight: 700,
                        backgroundColor: '#E3E6F2',
                        borderBottom: '1px solid #E1E3E9',
                        borderRadius: '0.5em',
                        padding: '0.5em 1em'
                    }}>ข้อมูลส่วนตัว</Box>

                    <Box sx={{
                        display: 'grid',
                        gridTemplateColumns: '1fr 1fr 1fr 1fr',
                        gridGap: '20px',
                        padding: '20px',
                        '@media (orientation: portrait)': {
                            gridTemplateColumns: '1fr',
                            gridGap: '0.75em',
                            padding: '0.75em',
                        }
                    }}>
                        <div>
                            <div style={{ fontWeight: 700, color: '#082C91' }}>ชื่อ-นามสกุล</div>
                            <div>{dataPersonal[0]?.['pname'] + dataPersonal[0]?.['fname'] + ' ' + dataPersonal[0]?.['lname']}</div>
                        </div>
                        <div>
                            <div style={{ fontWeight: 700, color: '#082C91' }}>ที่อยู่</div>
                            <div>{dataPersonal[0]?.['address']['full_address']}</div>
                        </div>
                        <div>
                            <div style={{ fontWeight: 700, color: '#082C91' }}>เลขประจำตัวประชาชน</div>
                            <div>{dataPersonal[0]?.['pid']}</div>
                        </div>
                        <div>
                            <div style={{ fontWeight: 700, color: '#082C91' }}>โทรศัพท์</div>
                            <div>{dataPersonal[0]?.['home_phone'] || '-'}</div>
                        </div>
                        <div>
                            <div style={{ fontWeight: 700, color: '#082C91' }}>วันเกิด</div>
                            <div>{convertDate(dataPersonal[0]?.['birthday'])}</div>
                        </div>
                        <div>
                            <div style={{ fontWeight: 700, color: '#082C91' }}>โทรศัพท์มือถือ</div>
                            <div>{dataPersonal[0]?.['phone_number'] || '-'}</div>
                        </div>
                        <div>
                            <div style={{ fontWeight: 700, color: '#082C91' }}>อายุ</div>
                            <div>{dataPersonal[0]?.['age'] + ' ปี'}</div>
                        </div>
                    </Box>
                </Box>
            }


            {value === 0 && showList.map((i, idx) => (
                <React.Fragment key={idx}>
                    <Box sx={{
                        border: 1,
                        borderRadius: '0.75em',
                        borderColor: '#E1E3E9',
                        bgcolor: '#FFF',
                        mx: 1,
                        '@media (orientation: portrait)': {
                            fontSize: '0.5em',
                        }
                    }}>
                        <Box sx={{
                            color: '#082C91',
                            fontWeight: 700,
                            backgroundColor: '#E3E6F2',
                            borderBottom: '1px solid #E1E3E9',
                            borderRadius: '0.5em',
                            padding: '0.5em 1em'
                        }}>ข้อมูลส่วนตัว</Box>

                        <Box sx={{
                            display: 'grid',
                            gridTemplateColumns: '1fr 1fr 1fr 1fr',
                            gridGap: '20px',
                            padding: '20px',
                            '@media (orientation: portrait)': {
                                gridTemplateColumns: '1fr',
                                gridGap: '0.75em',
                                padding: '0.75em',
                            }
                        }}>
                            <div>
                                <div style={{ fontWeight: 700, color: '#082C91' }}>ชื่อ-นามสกุล</div>
                                <div>{i['pname'] + i['fname'] + ' ' + i['lname']}</div>
                            </div>
                            <div>
                                <div style={{ fontWeight: 700, color: '#082C91' }}>ที่อยู่</div>
                                <div>{typeof i['address']['full_address'] === 'string' && i['address']['full_address'] !== '' ? i['address']['full_address'] : '-'}</div>
                            </div>
                            <div>
                                <div style={{ fontWeight: 700, color: '#082C91' }}>เลขประจำตัวประชาชน</div>
                                <div>{i['pid']}</div>
                            </div>
                            <div>
                                <div style={{ fontWeight: 700, color: '#082C91' }}>โทรศัพท์</div>
                                <div>{typeof i['home_phone'] === 'string' && i['home_phone'] !== '' ? i['home_phone'] : '-'}</div>
                            </div>
                            <div>
                                <div style={{ fontWeight: 700, color: '#082C91' }}>วันเกิด</div>
                                <div>{convertDate(i['birthday'])}</div>
                            </div>
                            <div>
                                <div style={{ fontWeight: 700, color: '#082C91' }}>โทรศัพท์มือถือ</div>
                                <div>{typeof i['phone_number'] === 'string' && i['phone_number'] !== '' ? i['phone_number'] : '-'}</div>
                            </div>
                            <div>
                                <div style={{ fontWeight: 700, color: '#082C91' }}>อายุ</div>
                                <div>{i['age'] + ' ปี'}</div>
                            </div>
                        </Box>
                    </Box>

                    <Box key={idx} sx={{ display: 'grid', gridGap: '0.5em', }}>
                        <Box sx={{
                            border: 1,
                            borderRadius: '0.75em',
                            borderColor: '#E1E3E9',
                            bgcolor: '#FFF',
                            mx: 1,
                            '@media (orientation: portrait)': {
                                fontSize: '0.5em',
                            }
                        }}>
                            <Box sx={{
                                color: '#082C91',
                                fontWeight: 700,
                                backgroundColor: '#E3E6F2',
                                borderBottom: '1px solid #E1E3E9',
                                borderRadius: '0.5em',
                                padding: '0.5em 1em'
                            }}>ข้อมูลทางการแพทย์</Box>

                            <Box sx={{
                                display: 'grid',
                                gridTemplateColumns: '1fr 1fr 1fr 1fr',
                                gridGap: '20px',
                                padding: '20px',
                                '@media (orientation: portrait)': {
                                    gridTemplateColumns: '1fr',
                                    gridGap: '0.75em',
                                    padding: '0.75em',
                                }
                            }}>
                                <div>
                                    <div style={{ fontWeight: 700, color: '#082C91' }}>โรงพยาบาล</div>
                                    <div>{typeof i['hos_name'] === 'string' && i['hos_name'] !== '' ? i['hos_name'] : '-'}</div>
                                </div>
                                <div>
                                    <div style={{ fontWeight: 700, color: '#082C91' }}>หมายเลขผู้ป่วยนอก</div>
                                    <div>{typeof i['hn'] === 'string' && i['hn'] !== '' ? i['hn'] : '-'}</div>
                                </div>
                                <div>
                                    <div style={{ fontWeight: 700, color: '#082C91' }}>กรุ๊ปเลือด</div>
                                    <div>{typeof i['blood_group'] === 'string' && i['blood_group'] !== '' ? i['blood_group'] : '-'}</div>
                                </div>
                                <div>
                                    <div style={{ fontWeight: 700, color: '#082C91' }}>แพ้ยา</div>
                                    <div>{typeof i['drug_allergy'] === 'string' && i['drug_allergy'] !== '' ? i['drug_allergy'] : '-'}</div>
                                </div>
                            </Box>
                        </Box>

                        <Box sx={{ margin: 'auto' }}>
                            <Pagination
                                count={maxPage}
                                page={page}
                                onChange={handlePageChange}
                                shape="circular"
                                color="c_yellow"
                                sx={{
                                    '& .MuiPaginationItem-root': {
                                        color: 'white', // text color
                                        height: '2em',
                                        width: '2em',
                                        fontSize: '0.625em'
                                    },
                                }}
                            />
                        </Box>
                    </Box>
                </React.Fragment>
            ))}

            {value === 0 ?
                <Box sx={{
                    display: 'grid',
                    gridGap: '30px',
                    mx:1,
                    '@media (orientation: portrait)': {
                        fontSize: '0.5em',
                    }
                }}>
                    <Box sx={{
                        border: 1,
                        borderColor: '#E1E3E9',
                        borderRadius: '0.75em',
                        bgcolor: '#FFF',
                        pb: 1,
                    }}>
                        <Box sx={{
                            color: '#082C91',
                            fontWeight: 700,
                            backgroundColor: '#E3E9F2',
                            borderBottom: '1px solid #E1E3E9',
                            borderRadius: '0.5em',
                            padding: '0.5em 1em'
                        }}>ค้นหา</Box>

                        <Box sx={{
                            display: 'grid',
                            gridTemplateColumns: '1fr 1fr',
                            padding: '1.25em',
                            '@media (orientation: portrait)': {
                                gridTemplateColumns: '1fr',
                                gridGap: '0.5em',
                                justifyItems: 'center',
                                padding: '0.625em'
                            },
                        }}>
                            <FormControl sx={{ width: '90%', color: '#082C91' }} size="small">
                                <div style={{ fontWeight: 700 }}>โรงพยาบาลที่เข้ารับบริการ</div>
                                <Select
                                    value={hospital || ' '}
                                    onChange={(event) => {
                                        const {
                                            target: { value },
                                        } = event;
                                        setHospital(value)
                                    }}
                                    sx={{ fontSize:'1em' }}
                                >
                                    <MenuItem value=" " sx={{ fontSize:'2em' }}>ทั้งหมด</MenuItem>
                                    {optionHospital.map((item, index) => (
                                        <MenuItem
                                            key={index}
                                            value={item['key']}
                                            sx={{ fontSize:'2em' }}
                                        >
                                            {item['value']}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>

                            <FormControl sx={{ width: '90%', color: '#082C91' }} size="small">
                                <div style={{ fontWeight: 700 }}>ค้นหาวันที่</div>
                                <Select
                                    value={date || ' '}
                                    onChange={(event) => {
                                        const {
                                            target: { value },
                                        } = event;
                                        setDate(value)
                                    }}
                                    sx={{ fontSize:'1em' }}
                                >
                                    <MenuItem value=" " sx={{ fontSize:'2em' }}>วันที่ทั้งหมด</MenuItem>
                                    {optionDate.map((item, index) => (
                                        <MenuItem
                                            key={index}
                                            value={item}
                                            sx={{ fontSize:'2em' }}
                                        >
                                            {convertDate(item)}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Box>
                    </Box>

                    {dataInformation.length > 0 ?
                        <>
                            {dataInformation.map((i, idx) => (
                                <Box sx={{
                                    display: 'grid',
                                    gridTemplateColumns: '1fr 4fr',
                                    border: 1,
                                    borderColor: '#E1E3E9',
                                    borderRadius: '0.5em',
                                    bgcolor: '#FFF',
                                    height: '400px',
                                    '@media (orientation: portrait)': {
                                        height: '90vw',
                                    }
                                }} key={idx}>

                                    <Box sx={{
                                        backgroundColor: '#E3E9F2',
                                        borderRadius: '0.5em',
                                        padding: '1em',
                                        display: 'grid',
                                        gridGap: '1em',
                                        '@media (orientation: portrait)': {
                                            px: '0.5em',
                                            gridGap: '0.5em',
                                        }
                                    }}>
                                        <Box sx={{
                                            color: '#082C91',
                                            fontWeight: 700,
                                            fontSize: '1.5em',
                                            textAlign: 'center',
                                            alignContent: 'center',
                                            '@media (orientation: portrait)': {
                                                fontSize: '1em',
                                            }
                                        }}>{convertDate(i['visit_date'])}</Box>

                                        { isPortrait ?
                                            <>
                                                <Tooltip title="ประวัติการแพทย์">
                                                    <IconButton
                                                        aria-label="Info"
                                                        onClick={() => { dataSetMenu(idx, 0) }}
                                                        variant={menuSelected[idx] === 0 ? "respSimp1" : "respSimp0"}
                                                        disableRipple
                                                    >
                                                        <BsClipboard2PulseFill size='1em'/>
                                                    </IconButton>
                                                </Tooltip>

                                                <Tooltip title="ผลแลป">
                                                    <IconButton
                                                        aria-label="Lab Results"
                                                        onClick={() => { dataSetMenu(idx, 1) }}
                                                        variant={menuSelected[idx] === 1 ? "respSimp1" : "respSimp0"}
                                                        disableRipple
                                                    >
                                                        <TbTestPipe size='1em'/>
                                                    </IconButton>
                                                </Tooltip>

                                                <Tooltip title="การวินิจฉัย">
                                                    <IconButton
                                                        aria-label="Diagnosis"
                                                        onClick={() => { dataSetMenu(idx, 2) }}
                                                        variant={menuSelected[idx] === 2 ? "respSimp1" : "respSimp0"}
                                                        disableRipple
                                                    >
                                                        <FaUserDoctor size='1em'/>
                                                    </IconButton>
                                                </Tooltip>

                                                <Tooltip title="การจ่ายยา">
                                                    <IconButton
                                                        aria-label="Prescription"
                                                        onClick={() => { dataSetMenu(idx, 3) }}
                                                        variant={menuSelected[idx] === 3 ? "respSimp1" : "respSimp0"}
                                                        disableRipple
                                                    >
                                                        <FaFilePrescription size='1em'/>
                                                    </IconButton>
                                                </Tooltip>
                                            </>
                                            :
                                            <>
                                                <Button onClick={() => { dataSetMenu(idx, 0) }} variant={menuSelected[idx] === 0 ? 'contained' : 'outlined'} sx={{fontSize:'1em'}}>ประวัติการแพทย์</Button>
                                                <Button onClick={() => { dataSetMenu(idx, 1) }} variant={menuSelected[idx] === 1 ? 'contained' : 'outlined'} sx={{fontSize:'1em'}}>ผลแลป</Button>
                                                <Button onClick={() => { dataSetMenu(idx, 2) }} variant={menuSelected[idx] === 2 ? 'contained' : 'outlined'} sx={{fontSize:'1em'}}>การวินิจฉัย</Button>
                                                <Button onClick={() => { dataSetMenu(idx, 3) }} variant={menuSelected[idx] === 3 ? 'contained' : 'outlined'} sx={{fontSize:'1em'}}>การจ่ายยา</Button>
                                            </>
                                        }

                                    </Box>

                                    <Box>
                                        {menuSelected[idx] === 0 ?
                                            <Box sx={{ padding: '20px', height: '350px', '@media (orientation: portrait)': {height: '80vw', pl:'0.75em'} }}>
                                                <Box sx={{ color: '#082C91', fontWeight: 700 }}>ประวัติการแพทย์</Box>
                                                {i['visit_information_list'].length > 0 ?
                                                    <Box sx={{ maxHeight: '100%', overflowY: "auto", scrollbarWidth: 'thin' }}>
                                                        {i['visit_information_list'].map((item, index) => (
                                                            <Box key={index} >
                                                                <Box sx={{ color: '#082C91', fontWeight: 700 }}>{item['hos_name']}</Box>
                                                                <Box sx={{
                                                                    display: 'grid',
                                                                    gridTemplateColumns: '1fr 1fr 1fr',
                                                                    margin: '1em',
                                                                    '@media (orientation: portrait)': {
                                                                        gridTemplateColumns: '1fr'
                                                                    }
                                                                }}>
                                                                    <Box>
                                                                        <div style={{ fontWeight: 700, color: '#082C91' }}>CC</div>
                                                                        <div style={{ margin: '0 1.5em', display: 'flex', wordBreak: 'break-word', overflowWrap: 'break-word' }}>{item['cc'] === '' ? '-' : item['cc']}</div>
                                                                    </Box>
                                                                    <Box>
                                                                        <div style={{ fontWeight: 700, color: '#082C91' }}>Ht</div>
                                                                        <div style={{ margin: '0 1.5em', display: 'flex', wordBreak: 'break-word', overflowWrap: 'break-word'  }}>{item['ht'] === '' ? '-' : item['ht']}</div>
                                                                    </Box>
                                                                    <Box>
                                                                        <div style={{ fontWeight: 700, color: '#082C91' }}>Pi</div>
                                                                        <div style={{ margin: '0 1.5em', display: 'flex', wordBreak: 'break-word', overflowWrap: 'break-word'  }}>{item['pi'] === '' ? '-' : item['pi']}</div>
                                                                    </Box>
                                                                    <Box>
                                                                        <div style={{ fontWeight: 700, color: '#082C91' }}>Bt</div>
                                                                        <div style={{ margin: '0 1.5em', display: 'flex', wordBreak: 'break-word', overflowWrap: 'break-word'  }}>{item['bt'] === '' ? '-' : item['bt']}</div>
                                                                    </Box>
                                                                    <Box>
                                                                        <div style={{ fontWeight: 700, color: '#082C91' }}>Pe</div>
                                                                        <div style={{ margin: '0 1.5em', display: 'flex', wordBreak: 'break-word', overflowWrap: 'break-word'  }}>{item['pe'] === '' ? '-' : item['pe']}</div>
                                                                    </Box>
                                                                    <Box>
                                                                        <div style={{ fontWeight: 700, color: '#082C91' }}>Rr</div>
                                                                        <div style={{ margin: '0 1.5em', display: 'flex', wordBreak: 'break-word', overflowWrap: 'break-word'  }}>{item['rr'] === '' ? '-' : item['rr']}</div>
                                                                    </Box>
                                                                    <Box>
                                                                        <div style={{ fontWeight: 700, color: '#082C91' }}>Bp</div>
                                                                        <div style={{ margin: '0 1.5em', display: 'flex', wordBreak: 'break-word', overflowWrap: 'break-word'  }}>{item['bp'] === '' ? '-' : item['bp']}</div>
                                                                    </Box>
                                                                    <Box>
                                                                        <div style={{ fontWeight: 700, color: '#082C91' }}>Bmi</div>
                                                                        <div style={{ margin: '0 1.5em', display: 'flex', wordBreak: 'break-word', overflowWrap: 'break-word'  }}>{item['bmi'] === '' ? '-' : item['bmi']}</div>
                                                                    </Box>
                                                                    <Box>
                                                                        <div style={{ fontWeight: 700, color: '#082C91' }}>Pr</div>
                                                                        <div style={{ margin: '0 1.5em', display: 'flex', wordBreak: 'break-word', overflowWrap: 'break-word'  }}>{item['pr'] === '' ? '-' : item['pr']}</div>
                                                                    </Box>
                                                                    <Box>
                                                                        <div style={{ fontWeight: 700, color: '#082C91' }}>sat O2</div>
                                                                        <div style={{ margin: '0 1.5em', display: 'flex', wordBreak: 'break-word', overflowWrap: 'break-word'  }}>{item['sat_o2'] === '' ? '-' : item['sat_o2']}</div>
                                                                    </Box>
                                                                    <Box>
                                                                        <div style={{ fontWeight: 700, color: '#082C91' }}>Bw</div>
                                                                        <div style={{ margin: '0 1.5em', display: 'flex', wordBreak: 'break-word', overflowWrap: 'break-word'  }}>{item['bw'] === '' ? '-' : item['bw']}</div>
                                                                    </Box>
                                                                </Box>
                                                            </Box>
                                                        ))}
                                                    </Box>
                                                    :
                                                    <NoData/>
                                                }
                                            </Box>
                                            : null
                                        }

                                        {menuSelected[idx] === 1 ?
                                            <Box sx={{ padding: '20px', height: '350px', '@media (orientation: portrait)': {height: '80vw', pl:'0.75em'} }}>
                                                <Box sx={{ color: '#082C91', fontWeight: 700 }}>ผลแลป</Box>
                                                {i['labs_information_list'].length > 0 ?
                                                    <Box sx={{ maxHeight: '100%', overflowY: "auto", scrollbarWidth: 'thin' }}>
                                                        {i['labs_information_list'].map((item, index) => (
                                                            <Box key={index}>
                                                                <Box sx={{ color: '#082C91', fontWeight: 700 }}>{item['hos_name']}</Box>
                                                                {item['lab_list'].map((lab, labIdx) => (
                                                                    <Box key={labIdx}>
                                                                        <Box sx={{ fontWeight: 700, color: '#082C91' }}>{lab['ordername']}</Box>
                                                                        <ul>
                                                                            {lab['detail'].map((detail, detailIdx) => (
                                                                                <li>
                                                                                    <Box key={detailIdx} sx={{ display: 'flex', wordBreak: 'break-word', overflowWrap: 'break-word' }}>
                                                                                        {detail}
                                                                                    </Box>
                                                                                </li>
                                                                            ))}
                                                                        </ul>
                                                                    </Box>
                                                                ))}
                                                            </Box>
                                                        ))}
                                                    </Box>
                                                    :
                                                    <NoData/>
                                                }
                                            </Box>
                                            : null
                                        }

                                        {menuSelected[idx] === 2 ?
                                            <Box sx={{ padding: '20px', height: '350px', '@media (orientation: portrait)': {height: '80vw', pl:'0.75em'} }}>
                                                <Box sx={{ color: '#082C91', fontWeight: 700 }}>การวินิจฉัย</Box>
                                                {i['diagnosis_information_list'].length > 0 ?
                                                    <Box sx={{ maxHeight: '100%', overflowY: "auto", scrollbarWidth: 'thin' }}>
                                                        {i['diagnosis_information_list'].map((item, index) => (
                                                            <Box key={index} >
                                                                <Box sx={{ color: '#082C91', fontWeight: 700, marginBottom: '20px' }}>{item['hos_name']}</Box>
                                                                <ul>
                                                                    {item['diagnosis'].map((diag, diagIdx) => (
                                                                        <li>
                                                                            <Box key={diagIdx} sx={{ display: 'flex', wordBreak: 'break-word', overflowWrap: 'break-word' }}>
                                                                                {diag['diag']}
                                                                            </Box>
                                                                        </li>
                                                                    ))}
                                                                </ul>
                                                            </Box>
                                                        ))}
                                                    </Box>
                                                    :
                                                    <NoData/>
                                                }
                                            </Box>
                                            : null
                                        }

                                        {menuSelected[idx] === 3 ?
                                            <Box sx={{ padding: '20px', height: '350px', '@media (orientation: portrait)': {height: '80vw', pl:'0.75em'} }}>
                                                <Box sx={{ color: '#082C91', fontWeight: 700 }}>การจ่ายยา</Box>
                                                {i['order_information_list'].length > 0 && i['order_information_list'][0]['order_list'].length > 0 ?
                                                    <Box sx={{ maxHeight: '100%', overflowY: "auto", scrollbarWidth: 'thin' }}>
                                                        {i['order_information_list'].map((item, index) => (
                                                            <Box key={index}>
                                                                <Box sx={{ color: '#082C91', fontWeight: 700, marginBottom: '20px' }}>{item['hos_name']}</Box>
                                                                {item['order_list'].length > 0 ?
                                                                    <ul>
                                                                        {item['order_list'].map((order, orderIdx) => (
                                                                            <li>
                                                                                <Box key={orderIdx} sx={{ display: 'flex', wordBreak: 'break-word', overflowWrap: 'break-word' }}>
                                                                                    {order['med']}
                                                                                </Box>
                                                                            </li>
                                                                        ))}
                                                                    </ul>
                                                                    :
                                                                    <NoData/>
                                                                }
                                                            </Box>
                                                        ))}
                                                    </Box>
                                                    :
                                                    <NoData/>
                                                }
                                            </Box>
                                            : null
                                        }
                                    </Box>
                                </Box>
                            ))}
                        </>
                        :
                        <NoData/>
                    }
                </Box>
                :
                <>
                </>
            }

        </Box>
    </>
    )
}